module.exports = __webpack_public_path__ + "static/media/Profile.af3188ed.svg";